var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.label[_vm.language]))])])}
var staticRenderFns = []

export { render, staticRenderFns }